import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import auth from 'helpers/auth';
import PageContainer from '../../layout/PageContainer';
import GarantiaPolicyDetailBasicInfo from './GarantiaPolicyDetailBasicInfo';
import { API, BASE_URL } from '../../../CONST';
import GarantiaPolicyDetailMovimientos from './GarantiaPolicyDetailMovimientos';

const GarantiaPolicyDetail = ({
  match: { params: { id } },
  location: { state },
}) => {
  const [ policy, setPolicy ] = useState(null);

  useEffect(() => {
    const url = `${BASE_URL}${API.fullGarantia}/${id}`;
    auth.fetch(url).then(response => {
      setPolicy(response);
    });
  }, [id]);

  return (
    <PageContainer
      breadcrumbs={[
        {id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        {id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-garantia' },
        {id: 2, name: 'PÓLIZAS GARANTÍA', url: '/asegurado/polizas-garantia' },
        {id: 3, name: 'DETALLE PÓLIZA'},
      ]}
      returnTo={policy && state && state.returnTo ? state.returnTo : ''}
    >
      <GarantiaPolicyDetailMovimientos policy={policy} />
      <GarantiaPolicyDetailBasicInfo policy={policy} />
    </PageContainer>
  );
};

GarantiaPolicyDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      returnTo: PropTypes.string,
    }),
  }).isRequired,
};

export default GarantiaPolicyDetail;
